import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * ATTENTION!
 *
 * If you just want to track some events, please use `ga` from `helpers/multitrack`
 */
import PropTypes from 'prop-types';
import React from 'react';
import cookie from 'cookie';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
var GA_INIT = "(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\nm=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n})(window,document,'script','//www.google-analytics.com/analytics.js','ga');";
export var dimensions = {
  EXPERIMENT_BRANCH: 'dimension4',
  USER_TYPE: 'dimension8',
  EXPERIMENT: 'dimension9',
  PROMOTION: 'dimension16',
  USER_ID: 'dimension17'
};
export var getExperimentBranch = function getExperimentBranch(testId, variantId) {
  return testId ? "test_".concat(testId, "_variant_").concat(variantId) : null;
}; // This lives outside of the component so it can be used in places that are
// not in the component heirarchy (such as sagas).

var safeGa = function ga() {
  var gaFn = (__CLIENT__ || __TEST__) && typeof window.ga !== 'undefined' && window.ga;

  if (gaFn !== 'undefined' && gaFn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (__CLIENT__ && readLocalStorage('trackingDebug')) {
      var _console;

      (_console = console).info.apply(_console, ['Tracking ga'].concat(args)); // eslint-disable-line no-console

    }

    gaFn.apply(void 0, args);
  }
};

export var GoogleAnalytics =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GoogleAnalytics, _React$Component);

  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);

    return _possibleConstructorReturn(this, _getPrototypeOf(GoogleAnalytics).apply(this, arguments));
  }

  _createClass(GoogleAnalytics, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var cookies = cookie.parse(document.cookie);
      safeGa('set', dimensions.USER_TYPE, cookies.cpUserType || 'prospect');
      safeGa('send', 'pageview');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          currentPath = _this$props.currentPath,
          userId = _this$props.userId; // Track a GA page view if the URL changes

      if (currentPath !== prevProps.currentPath) {
        safeGa('send', 'pageview');
      }

      if (!prevProps.userId && userId) {
        safeGa('set', dimensions.USER_ID, String(userId));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          accountKey = _this$props2.accountKey,
          cookieDomain = _this$props2.cookieDomain,
          userId = _this$props2.userId;
      var initLines = [];
      initLines.push("ga('create', '".concat(accountKey, "', { cookieDomain: '").concat(cookieDomain, "' });")); // Optimizely Universal Analytics Integration

      initLines.push('window.optimizely = window.optimizely || [];');
      initLines.push('window.optimizely.push("activateUniversalAnalytics");');

      if (userId) {
        initLines.push("ga('set', 'userId', '".concat(userId, "');"));
        initLines.push("ga('set', '".concat(dimensions.USER_ID, "', '").concat(userId, "');"));
      }

      return React.createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: "".concat(GA_INIT, "\n").concat(initLines.join('\n')).replace(/\n/g, '')
        }
      });
    }
  }]);

  return GoogleAnalytics;
}(React.Component);

_defineProperty(GoogleAnalytics, "sendPageView", function (path, customDimensions) {
  safeGa('send', _objectSpread({
    page: path,
    hitType: 'pageview'
  }, customDimensions));
});

GoogleAnalytics.propTypes = {
  currentPath: PropTypes.string.isRequired,
  accountKey: PropTypes.string.isRequired,
  cookieDomain: PropTypes.string.isRequired,
  userId: PropTypes.number
};